import { Component } from '@angular/core';
import { SITE_DATA } from '../productization/default.constant';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrls: ['./terms-of-service.component.scss'],
    imports: [RouterLink]
})
export class TermsOfServiceComponent {
	public customData: any = SITE_DATA.termOfService;
}
